export default __webpack_public_path__ + "static/media/compliance-hero.jpg";